import React from 'react';
import Big from 'big.js';
import { BodyText, SMALL_PRECISION } from '@make-software/cspr-design';
import { CsprAmount, motesToCSPR, PrecisionCase } from '../../../components';
import FiatCurrency from '../../../components/multi-currency/multi-currency';

interface DeployFiatAmountProps {
  amount: string | null;
  rate: number;
}

const DeployFiatAmount = ({ amount, rate }: DeployFiatAmountProps) => {
  const csprAmount = amount ? motesToCSPR(amount) : 0;
  const currencyAmount =
    rate && csprAmount ? Big(csprAmount).mul(rate).toString() : null;

  return (
    <>
      <BodyText size={3} monotype variation={'black'}>
        <CsprAmount motes={amount} precisionCase={PrecisionCase.small} />
      </BodyText>
      <BodyText size={3} monotype variation="darkGray">
        (
        <FiatCurrency amount={currencyAmount} precision={SMALL_PRECISION} />)
      </BodyText>
    </>
  );
};

export default DeployFiatAmount;
